<template>
    <div>
        <div class="ProductOnSale">
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-select v-model="state" placeholder="申购单状态" size="mini" @change="changeState">
                        <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="zbstate" placeholder="招标状态" size="mini" @change="zbchangeState" v-if="state==3">
                        <el-option
                                v-for="item in zbstateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input
                            style="width: 220px"
                            size="mini"
                            class="input"
                            placeholder="搜索品种"
                            v-model="pzSearchData"
                            clearable>
                    </el-input>
                    <el-date-picker
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            size="mini"
                            class="input"
                            v-model="startDate"
                            type="date"
                            placeholder="申请日期(开始)"
                    >
                    </el-date-picker>
                    <el-date-picker
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            size="mini"
                            class="input"
                            v-model="endDate"
                            type="date"
                            placeholder="申请日期(结束)"
                    >
                    </el-date-picker>
                    <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="searchData" size="mini"></el-button>
                    <el-button class="mrl20" icon="el-icon-refresh" circle  @click="clearSearchData" size="mini"></el-button>
                </div>

                    <!--<el-select v-model="state" placeholder="请选择" size="mini">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>-->
                <el-button class="marB10" style="height: fit-content" @click="addSub" :class="baseerp+'btn'" size="mini">
                    新增申购
                </el-button>
            </div>
        <el-table
                class="mrt10"
                ref="table"
                size="mini"
                :height="tableHeight"
                border
                :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="true"
                style="width: 100%">
            <el-table-column label="编号" align="center" prop="i_id" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="申购单状态"
                    prop="stateTxt" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span :class="scope.row.status==3&&scope.row.i_offline==0?'green':scope.row.status==-2?'gray':scope.row.status==1||scope.row.status==2?'orange':scope.row.status==3&&scope.row.i_offline==1?'blue':'red'">{{scope.row.stateTxt}}</span>
                </template>
            </el-table-column>

            <el-table-column
                    align="center"
                    :label="$t('form_product_name')"
                    prop="product_kind" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.product_kind+' '+scope.row.model}}
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="要求"
                    prop="buyrequire" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="需求数量"
                    prop="quantity" show-overflow-tooltip>
            </el-table-column><el-table-column
                align="center"
                label="采购数量"
                prop="bidnum" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="截止日期"
                    sortable
                    prop="end_date" show-overflow-tooltip>
            </el-table-column>
            <el-table-column  align="center" label="申购公司"
                    prop="apply_ent_name" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="申购部门"
                    prop="depart_name" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                align="center"
                label="申购人"
                prop="applicant_name" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="申请日期"
                    sortable
                    prop="apply_date" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="采购状态"
                    prop="requireStateTxt" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="采购操作人"
                    prop="requireLruname" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" width="140" align="center">
                <template slot-scope="scope">
                    <el-button  size="mini" type="text" @click="details(scope.row)" >查看</el-button>

                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        layout="total,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total"
                        :page-size="pageSize">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog :title="title"
                       width="95%"
                       top="30"
                       :visible.sync="dialogTableVisible"
                       :close-on-click-modal="false"
            @close="closeDetailsFun">

                <add-subscribe v-if="dialogTableVisible" :data="subscribeData" @close="closeDetailsFun" @refresh="refresh"></add-subscribe>
            </el-dialog>
        </div>

    </div>
    </div>
</template>

<script>
    import * as API from "../api";
    import {baseerp} from "@/utils/baseUrl";
    import {mapActions} from "vuex";
    import AddSubscribe from "./compontents/AddSubscribe";

    // import AddSubscribe from "../compontents/AddSubscribe";
    export default {
        name: "index",
        components: {AddSubscribe},
        data() {
            return {
                startDate:'',
                endDate:'',
                pzSearchData:"",
                subscribeData:{},
                tableData:[],
                treespan:4,
                rightspan:20,
                showDetails:false,
                baseerp: "",
                dialogTableVisible:false,
                pageSize:20,
                currentPage:1,
                total:0,
                title:'新增申购',
                state:0,
                zbstate:0,
                stateList:[
                    {value:0,label:'全部状态'},
                    {value:1,label:'待提交'},
                    {value:2,label:'审核中'},
                    {value:3,label:'审核通过'},
                    {value:4,label:'审核未通过'},
                    {value:5,label:'线下采购'},
                    {value:-2,label:'已作废'},
                    {value:-3,label:'已驳回'},
                ],
                zbstateList:[
                    {value:0,label:'全部状态'},
                    {value:1,label:'未招标'},
                    {value:2,label:'招标中'},
                    {value:3,label:'已中标'},
                    {value:4,label:'已流标'},
                ],
                tableHeight:0,
                activePage:"report/res/spread.vue",

            }
        },
        mounted() {
            this.baseerp=baseerp
            this.applyBuyList();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            clearSearchData(){
                this.currentPage=1
                this.startDate=''
                this.endDate=''
                this.pzSearchData=''
                this.state=0
                this.zbstate=0
                this.applyBuyList();

            },
            searchData(){
                this.currentPage=1
                this.applyBuyList()
            },
            addSub(){
                this.title="新增申购"
                this.dialogTableVisible=true
                this.subscribeData={
                    i_id:0,
                    status:0,
                    i_mid:this.mid
                };
            },
            details(row){
                this.subscribeData=row;
                this.subscribeData.i_mid=this.mid;
                this.dialogTableVisible=true
                this.title="查看"+row.i_id+"详情"
            },

            changeState(val){
                this.state=val
                this.currentPage=1
                this.applyBuyList()
            },
            zbchangeState(val){
                this.zbstate=val
                this.currentPage=1
                this.applyBuyList()
            },
            async applyBuyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id);
                } else {
                    this.mid = sessionStorage.getItem('mids');
                }
                let param={
                    i_mid: this.mid,
                    status:this.state,
                    apply_date:this.startDate,
                    end_date:this.endDate,
                    vc_search:this.pzSearchData,
                    pageSize:this.pageSize,
                    currentPage:this.currentPage,
                    i_purstate:this.zbstate,
                };
                let res=await API.applyBuyList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.list;
                    this.total=res.data.total;
                    // console.log(this.tableData,"this.tableData")
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            showDetailsFun(){
                this.dialogTableVisible=true
            },
            closeDetailsFun(type='back'){
                this.dialogTableVisible=false
                this.subscribeData={}
            },
            refresh(){
                if(this.subscribeData.i_id==0){
                    this.currentPage=1
                }
                this.applyBuyList()
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.applyBuyList();
            },

        },

    }
</script>

<style lang="scss" scoped>
    .ProductOnSale{
        margin: 10px 14px;
    }
    .mrt10{
        margin-top: 10px;
    }
    /deep/{
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-dialog{
            margin:30px auto;
        }
    }
    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .blue{
        color: #409eff;
    }
    .gray{
        color: #909399;
    }
    .red{
        color: #f56c6c;
    }
</style>